<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">Admit Patient</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body" v-if="loading">
        <loader />
      </div>

      <!-- Body -->
      <div v-if="!loading" class="modal-body">
        <form @submit.prevent="admitPatient">
          <!-- Ward -->
          <div class="form-group">
            <label for="ward">Ward</label>
            <select
              @change="fetch_beds"
              v-model="form.ward"
              id="ward"
              class="form-control"
              required
            >
              <option disabled value="">Select Ward</option>
              <option v-for="ward in wards" :key="ward.id" :value="ward.id">
                {{ ward.ward_name }}
              </option>
            </select>
          </div>

          <!-- Bed -->
          <div class="form-group">
            <label for="bed">Bed</label>
            <select v-model="form.bed" id="bed" class="form-control" required>
              <option disabled value="">Select Bed</option>
              <option v-for="bed in beds" :key="bed.id" :value="bed.id">
                {{ bed.bed_number }}
              </option>
            </select>
          </div>

          <!-- Admission Notes -->
          <!-- <div class="form-group">
            <label for="notes">Admission Notes</label>
            <textarea
              id="notes"
              v-model="form.notes"
              class="form-control"
              rows="3"
              placeholder="Enter notes"
            ></textarea>
          </div> -->

          <!-- Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary">Admit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import loader from "../../special_clinics/dialysis/loader.vue";
export default {
  name: "AdmitPatientModal",
  props: {
    visit_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        ward: "",
        bed: "",
        notes: "",
      },
      loading: false,
      wards: [],
      beds: [],
    };
  },
  components: {
    loader,
  },
  methods: {
    closeModal() {
      this.$emit("close-admission-modal");
    },
    async admitPatient() {
      this.loading = true;
      const resp = await generalApiRequest(
        "inpatient/admit",
        "POST",
        {
          visit_id: this.visit_id,
          ward: this.form.ward,
          bed: this.form.bed,
          notes: this.form.notes,
        },
        1
      );
      this.loading = false;
      if (resp) {
        this.closeModal();
      } else {
        console.log("err");
        this.closeModal();
      }
    },
    async fetch_wards() {
      this.loading = true;
      const wards = await generalApiRequest(
        "inpatient/getCompanyWards",
        "GET",
        {},
        1
      );
      this.wards = wards;
      this.loading = false;
    },
    async fetch_beds() {
      // console.log("executing===");
      this.form = { ...this.form, bed: "" };
      this.loading = true;
      const beds = await generalApiRequest(
        "inpatient/findCompanyBeds",
        "POST",
        {
          ward_id: this.form.ward,
          beds_to_query: "all_in_a_ward_free",
        },
        1
      );
      this.beds = beds;
      this.loading = false;
    },
  },
  mounted() {
    this.fetch_wards();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  padding-top: 0.5rem;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

.form-group {
  margin-bottom: 1rem;
}
</style>
